export default __webpack_public_path__ + "static/media/marketing.cfa67ccd.svg";